import {AfterViewInit, Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {AlertListService} from '@xref/ngx';
import * as Cookies from 'js-cookie';
import {environment} from '../../../../../environments/environment';
import {ElementHelperService} from '../../../../services/element-helper/element-helper.service';
import {StylingCheckService} from '../../../../services/styling-check/styling-check.service';
import {IdService} from '../../../../services/id/id.service';
import Constants from '../../../../shared/constants';
import {NgForm} from '@angular/forms';
import {PermissionsService} from "src/app/services/permissions/permissions.service";
const uuidv1 = require('uuid/v1');

@Component({
    selector: 'xlog-login-form',
    templateUrl: './login-form.component.pug',
    styleUrls: ['./login-form.component.scss'],
    standalone: false
})
export class LoginFormComponent implements OnInit, AfterViewInit {

    @ViewChild('formRef') form: NgForm;
    @ViewChild('email') email: any;

    @Output() isPendingVerification = new EventEmitter();

    platform: 'xsp' | 'xrp' = 'xrp';
    originData: any;
    loading = false;
    model = { email: '', password: '' };
    hasOrigin = false;
    submittedLogin = false;
    gettingOrigin = false;
    submittedOrigin = false;
    regions: string[] = [];
    selectedRegion = 'au';
    sso = {
        sso_url: '',
        sso_type: '',
        is_sso_enabled: false
    };

    formActionKeys: any = {
        continue: 'continue',
        signIn: 'signIn'
    };
    formActionI18nKey: string;

    private _lastOriginEmail = '';
    private _resetOriginTimeout: any;

    constructor(
        private id: IdService,
        private alertList: AlertListService,
        private router: Router,
        private el: ElementHelperService,
        private stylingCheckService: StylingCheckService,
        private featureFlagService: PermissionsService
    ) { }

    ngOnInit() {
        this.formActionI18nKey = this.formActionKeys.continue;
        this.resetEmailForm();
        this.stylingCheckService.setClassic(false);
        this.id.ent_9105 = this.featureFlagService.isFeatureActivated('ENT-9105-PENETRATION-TEST-2025');
    }

    ngAfterViewInit() {
        this.el.focusById('email');
    }

    resetEmailForm() {
    // Fixes obscure error (Observed in SSO flow):
    // Clicking back button into login with browser pre-filled email does not sync with Angular form
        setTimeout(() => {
            const emailEl = document.getElementById('email') as HTMLInputElement;
            const passwordEl = document.getElementById('password') as HTMLInputElement;
            this.form.setValue({
                email: emailEl?.value || '',
                password: passwordEl?.value || ''
            });
        }, 0);
    }

    nextAction() {
        if (this.hasOrigin && this.originData && this.originData.is_sso_enabled) {
            this.ssoRedirect();
        } else if (this.hasOrigin) {
            this.login();
        } else {
            this.getOrigin();
        }
    }

    login() {
        this.submittedLogin = true;

        if (this.hasOrigin && this.model.password.length > 0) {
            const credentials = {'useremail': this.model.email, 'password': this.model.password};
            if (this.selectedRegion && this.originData.region_orgs && this.originData.region_orgs.hasOwnProperty(this.selectedRegion)) {
                credentials["organisation_uuid"] = this.originData.region_orgs[this.selectedRegion];
            } else if (Cookies.get(Constants.ORG_UID) != 'undefined') {
                credentials["organisation_uuid"] = Cookies.get(Constants.ORG_UID);
            }
            this.id.login(this.loginSuccess, this.loginError, credentials);
            this.loading = true;
        }
    }

    loginSuccess = () => {
        this.loading = false;
    };

    loginError = (error: any) => {
        if (error.status_message === 'maintenance_omni') {
            this.alertList.append([{active: true, type: 'danger', messageKey: 'alerts.auth.MAINTENANCE_OMNI'}]);
        } else if (error.status_message === 'connectivity_error') {
            this.alertList.append([{active: true, type: 'danger', messageKey: 'alerts.connectivityError'}]);
        } else if (error.status_message === 'client_error' && error.message === "Incorrect login credentials.") {
            this.alertList.append([{ active: true, type: 'danger', messageKey: `alerts.auth.${error.message}` }]);
        } else if (error.status_message === 'client_error' && error.data && error.data.hasOwnProperty('xref_error')) {
            // omni errors
            if (error.data.xref_error.key === 'FAILED_LOGIN_ATTEMPT') {
                // On failed login attempt take translation key from detail attribute since these map to specific error messages
                this.alertList.append([{ active: true, type: 'danger', messageKey: `alerts.auth.${error.data.xref_error.detail}` }]);
            }
            // xref classic errors
            if (error.data.xref_error.key === 'XREF_CHANGE_PASSWORD') {
                // On change password redirect user to change password page with token
                this.alertList.append([{ active: true, type: 'danger', messageKey: 'alerts.auth.XREF_CHANGE_PASSWORD', keepOnRouteChange: true }]);
                this.router.navigate(['change-password', { t: error.data.xref_error.detail }]);

            } else if (error.data.xref_error.key === 'XREF_PASSWORD_EXPIRED') {
                // On change password redirect user to change password page with token
                this.alertList.append([{ active: true, type: 'danger', messageKey: 'alerts.auth.XREF_PASSWORD_EXPIRED', keepOnRouteChange: true }]);
                this.router.navigate(['change-password', { t: error.data.xref_error.detail }]);

            } else if (error.data.xref_error.key === 'XREF_USER_INACTIVE') {
                // On change password redirect user to change password page with token
                this.alertList.append([{ active: true, type: 'danger', messageKey: 'alerts.auth.XREF_USER_INACTIVE', keepOnRouteChange: true }]);

            } else if (error.data.xref_error.key === 'XREF_MULTI_FACTOR_SETUP' || error.data.xref_error.key === 'XREF_MULTI_FACTOR_VERIFY') {
                this.id.setToken(Constants.PLATFORM, error.data.platform);
                this.id.setToken(Constants.API_REGION_TOKEN, error.data.region);
                this.id.setToken(Constants.ORG_UID, error.data.org);
                // On 2fa response redirect user to two factor page with token
                this.router.navigate(['two-factor', { t: error.data.xref_error.detail }]);

            } else if (error.data.xref_error.key === 'FAILED_LOGIN_ATTEMPT') {
                // On failed login attempt take translation key from detail attribute since these map to specific error messages
                this.alertList.append([{ active: true, type: 'danger', messageKey: `alerts.auth.${error.data.xref_error.detail}` }]);

            } else if (error.data.xref_error.key === 'XREF_PASSWORD_EXPIRED') {
                // On change password redirect user to change password page with token
                this.alertList.append([{ active: true, type: 'danger', messageKey: 'alerts.auth.XREF_PASSWORD_EXPIRED', keepOnRouteChange: true }]);
                this.router.navigate(['change-password', { t: error.data.xref_error.detail }]);

            } else if (error.data.xref_error.key === 'XREF_USER_NOT_VERIFIED') {
                this.isPendingVerification.emit({
                    value: true,
                    email: this.email.value
                });

            } else {
                this.alertList.append([{ active: true, type: 'danger', messageKey: `alerts.auth.${error.data.xref_error.key}` }]);
            }
        } else {
            this.alertList.append([{ active: true, type: 'danger', messageKey: 'alerts.generic.error' }]);
        }

        this.loading = false;
    };

    getOrigin() {
        this.submittedOrigin = true;

        if (this.model.email.length > 0) {
            this.gettingOrigin = true;
            this.loading = true;
            // Make sure Trust access cookie is cleared
            Cookies.remove(Constants.TRUST_ACCESS, {domain: environment.DOMAIN});
            Cookies.set(Constants.LOGIN_EMAIL, this.model.email, {domain: environment.DOMAIN});
            this.id.getOriginObservable(this.model.email).subscribe(
                this.getOriginSuccess,
                this.getOriginError
            );
        }
    }

    setRegions() {
        this.regions = this.originData.regions ? this.originData.regions : [];
        this.selectedRegion = this.regions.length > 0 ? this.regions[0] : '';
    }

    checkSSO() {
        // SSO enabled email domains
        if (this.originData.is_sso_enabled) {
            // If only one region selection available or platform is XSP, add selected region and redirect user to SSO
            if (this.regions.length <= 1 || this.originData.platform === 'xsp') {
                this.ssoRedirect();
            }
        }
    }

    getOriginSuccess = (data) => {
        this._lastOriginEmail = this.model.email?.trim();
        this.originData = data.data;
        this.platform = this.originData.platform;
        this.setRegions();
        this.selectedRegion = this.originData.is_sso_enabled ? '' : this.selectedRegion;
        if (this.originData.is_sso_enabled) {
            Cookies.set(Constants.ORG_UID, this.originData.org_uuid, {domain: environment.DOMAIN});
            Cookies.set(Constants.PLATFORM, this.platform, {domain: environment.DOMAIN});
            this.checkSSO();
        }
        this.hasOrigin = true;
        this.loading = this.gettingOrigin = false;
        // Focus password input field
        this.el.focusById('password');
        this.formActionI18nKey = this.formActionKeys.signIn;
    };

    getOriginError = () => {
        this.gettingOrigin = this.hasOrigin = this.loading = false;
    };

    onEmailInput() {
        const currentEmail = this.model.email?.trim();

        // Ignore autofill or synthetic events
        if (!currentEmail || !this._lastOriginEmail) return;

        if (this.hasOrigin && currentEmail !== this._lastOriginEmail) {
            this.resetOrigin();
        }
    }

    resetOrigin() {
        if (this.hasOrigin && this.model.email !== this._lastOriginEmail) {
            this.hasOrigin = false;
            this.formActionI18nKey = this.formActionKeys.continue;

            // Reset any SSO configuration
            this.platform = 'xrp';
            this.originData = null;
        }
    }

    regionSelectedHandler(region: any) {
        this.selectedRegion = region;
        Cookies.set(Constants.API_REGION_TOKEN, region, { domain: environment.DOMAIN });
        Cookies.set(Constants.ORG_UID, this.originData.region_orgs[region], {domain: environment.DOMAIN});
        if (this.originData.is_sso_enabled) {
            this.ssoRedirect();
        }
    }

    private ssoRedirect() {
        const UUID = uuidv1();
        const nonce = uuidv1();
        const type = this.originData.sso_type;
        const url = this.originData.sso_url;
        const redirectUrl = `${environment.LOGIN_APP_URL}${Constants.SSO_URLS[type]}`;

        // Store UUID for verification when returning to App
        Cookies.set(Constants.SSO_UUID, UUID, { domain: environment.DOMAIN });
        Cookies.set(Constants.SSO_NONCE, nonce, { domain: environment.DOMAIN });

        // Store redirect URL for verification when returning to App
        Cookies.set(Constants.SSO_REDIRECT_URL, redirectUrl, { domain: environment.DOMAIN });

        if (type.toLocaleLowerCase() === 'saml') {
            // Store selected region for getting data for that region when returning to App
            Cookies.set(Constants.SSO_REDIRECT_URL, redirectUrl, { domain: environment.DOMAIN });
            location.assign(`${url}`);
        }
        location.assign(`${url}&state=${UUID}&redirect_uri=${redirectUrl}&nonce=${nonce}`);
    }
}
